import { atom } from 'jotai';

/**
 * Whether the Heidi II explore-later strip is on screen. The banner is the
 * only writer. Other top chrome, such as the Scribe 2 banners, reads it so
 * the two never show together.
 */
export const heidi2ExploreLaterBannerVisibleAtom = atom(false);
